import React from 'react'
import { Grid, Separator, Heading, Button } from '@design-systems/canvas-ui'
import { useNavigate } from 'react-router-dom'
import { HeaderMegaMenuOptions } from '../../constants/headerMegaMenuOptions'
import styles from './header.module.scss'

export const PopoverContent = ({ selectedHeaderOption }) => {
  const navigate = useNavigate()
  const menuOption =
    HeaderMegaMenuOptions.find(
      (opt) => opt.headerMainTitle === selectedHeaderOption,
    ) || HeaderMegaMenuOptions[0]

  return (
    <Grid.Container
      direction="row"
      className={styles.popoverPanel}
      justify="space-between"
      spacing="none"
    >
      <Grid.Item size={{ xs: 2 }} className={styles.popoverImage}>
        {menuOption.img}
      </Grid.Item>
      <Separator direction="vertical" className={styles.headerSeparator} />
      <Grid.Item size={{ xs: 7 }}>
        <Grid.Container direction="column" align="start" spacing="none">
          {menuOption.menuSelection.map((option) => (
            <Grid.Item
              size={{ xs: 12 }}
              className="hc8-pb-6x"
              key={option.name}
            >
              <Button
                variant="ghost"
                className="hc8-ta-left hc8-pv-6x hc8-pl-0 hc8-pr-6x"
                size="lg"
                onClick={() => {
                  navigate(option.href)
                  window.scrollTo(0, 0)
                }}
              >
                <Grid.Item className={`hc8-pr-2x ${styles.menuIcon}`}>
                  {option.icon}
                </Grid.Item>
                <Grid.Item>
                  <Grid.Container>
                    <Grid.Item>
                      <div className="hc8-clr-base hc8-fs-150 hc8-pb-1x">
                        <strong>{option.name}</strong>
                      </div>
                      <div className="hc8-clr-base hc8-fs-100">
                        {option.description}
                      </div>
                    </Grid.Item>
                  </Grid.Container>
                </Grid.Item>
              </Button>
            </Grid.Item>
          ))}
        </Grid.Container>
      </Grid.Item>
      <Separator direction="vertical" className={styles.headerSeparator} />
      <Grid.Item size={{ xs: 2 }}>
        <Heading>
          Grow with <span className={styles.headingMegaMenu}>Target Plus</span>
        </Heading>
        <div className="hc8-clr-base hc8-fs-150 hc8-pt-3x">
          Join Target Plus and unlock access to millions of loyal Target guests
          on a marketplace built for trust and success.
        </div>
      </Grid.Item>
    </Grid.Container>
  )
}

export default PopoverContent
